export default __webpack_public_path__ + "static/media/messmate.bfcbb21c.svg";